export default "__VITE_ASSET__b813325f__"